import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

export const exportToExcel = (options) => {
  try {
    const { data, columns, fileName = 'export', sheetName = 'Sheet1' } = options;
    
    // Prepare the data for Excel
    const excelData = data.map(item => {
      const row = {};
      columns.forEach(col => {
        row[col.header] = item[col.key];
      });
      return row;
    });

    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    
    // Add worksheet to workbook and save
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
    
  } catch (error) {
    console.error('Excel export error:', error);
    throw error;
  }
};

export  const exportToPDF = (options) => {
            try {
                const {
                    data,
                    columns,
                    fileName = 'export',
                    title = 'Export',
                    dateRange,
                    selectedCustomer,
                    totalAmount,
                    customContent,
                    footer
                } = options;

                const doc = new jsPDF();

                // Set default font and text color
                doc.setFont('helvetica', 'normal');
                doc.setTextColor(30, 30, 30); // Darker text for readability

                let currentY = 10; // Initial Y position for content

                // Add custom content if provided
                // The customContent function is expected to return the new Y position
                if (customContent) {
                    currentY = customContent(doc, currentY);
                } else {
                    // Default title if no custom content is provided
                    doc.setFontSize(22);
                    doc.setFont(undefined, 'bold');
                    doc.text(title, doc.internal.pageSize.width / 2, currentY + 10, { align: 'center' });
                    doc.setFont(undefined, 'normal');
                    currentY += 25;
                }

                // Prepare table data
                const headers = columns.map(col => col.header);
                const body = data.map(item =>
                    columns.map(col => item[col.key] || '')
                );

                // Define column styles for alignment
                const columnStyles = columns.reduce((styles, col, index) => {
                    // Right align for numeric columns (Qty, Rate, Amount)
                    if (['quantity', 'saleRate', 'amount'].includes(col.key)) {
                        styles[index] = { cellWidth: col.width || 'auto', halign: 'right' };
                    } else {
                        styles[index] = { cellWidth: col.width || 'auto' };
                    }
                    return styles;
                }, {});


                // Add table
                doc.autoTable({
                    head: [headers],
                    body: body,
                    startY: currentY, // Start table after custom content
                    styles: {
                        overflow: 'linebreak',
                        fontSize: 10,
                        cellPadding: 3,
                        textColor: 50,
                        lineColor: 200,
                        lineWidth: 0.1
                    },
                    headStyles: {
                        fillColor: [62, 126, 179], // A professional blue color for header
                        textColor: 255, // White text
                        fontStyle: 'bold',
                        fontSize: 11,
                        halign: 'center' // Center align header text by default
                    },
                    bodyStyles: {
                        valign: 'middle'
                    },
                    alternateRowStyles: {
                        fillColor: [240, 240, 240] // Light grey for alternate rows
                    },
                    columnStyles: columnStyles,
                    margin: { top: 10, left: 14, right: 14 }, // Consistent margins
                    didDrawPage: function (data) {
                        // Footer logic moved here to apply to all pages
                        if (footer) {
                            footer(doc, doc.internal.pageSize.height - 20); // Position footer near bottom
                        }
                    }
                });

                // Add Total Amount after the table
                const finalY = doc.lastAutoTable.finalY || currentY; // Get the Y position after the table
                doc.setFontSize(12);
                doc.setFont(undefined, 'bold');
                doc.text(`Total Amount: Rs ${totalAmount.toFixed(2)}`, doc.internal.pageSize.width - 14, finalY + 10, { align: 'right' }); // Right-aligned
                doc.setFont(undefined, 'normal');


                // Save the PDF
                doc.save(`${fileName}.pdf`);

            } catch (error) {
                console.error('PDF export error:', error);
                // In a real app, you might show a user-friendly error message here
                // e.g., using a custom modal or toast notification
                // alert('Failed to generate PDF. Please try again.');
            }
        };